import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import CardEndcap from "../components/CardEndcap";
function CardFooter(param) {
    var orientation = param.orientation, children = param.children;
    return _jsx(CardEndcap, {
        orientation: orientation,
        capType: 'footer',
        children: children
    });
}
export default CardFooter;
